module.exports = "pegasus_template/assets/text-button-with-background-preview.png";